// Author YuJiaBei
// Date 2021-02-24 09:23:01

class EmAdmSysOperateLog {
constructor({
        id = null,
        moduleName = '',
        domainName = '',
        name = '',
        logLevel = '',
        handleStatus = '',
        exceptionMessage = '',
        exceptionStack = '',
        userLoginName = '',
        operateTime = '',
        businessKey = '',
        businessType = '',
        businessDetail = '',
        businessRemark = '',
        dataId = '',
        dataEntityClass = '',
        oldData = '',
        newData = '',
        method = '',
        params = '',
        ipAddress = '',
        browser = '',
        operateDuration = '',
        remark = ''}
= {}) {
    this.id = id;
    this.moduleName = moduleName;
    this.domainName = domainName;
    this.name = name;
    this.logLevel = logLevel;
    this.handleStatus = handleStatus;
    this.exceptionMessage = exceptionMessage;
    this.exceptionStack = exceptionStack;
    this.userLoginName = userLoginName;
    this.operateTime = operateTime;
    this.businessKey = businessKey;
    this.businessType = businessType;
    this.businessDetail = businessDetail;
    this.businessRemark = businessRemark;
    this.dataId = dataId;
    this.dataEntityClass = dataEntityClass;
    this.oldData = oldData;
    this.newData = newData;
    this.method = method;
    this.params = params;
    this.ipAddress = ipAddress;
    this.browser = browser;
    this.operateDuration = operateDuration;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmSysOperateLog();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'moduleName',
        label: 'label.em.admin.emAdmSysOperateLog.grid.moduleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'domainName',
        label: 'label.em.admin.emAdmSysOperateLog.grid.domainName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysOperateLog.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'logLevel',
        label: 'label.em.admin.emAdmSysOperateLog.grid.logLevel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'handleStatus',
        label: 'label.em.admin.emAdmSysOperateLog.grid.handleStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'exceptionMessage',
        label: 'label.em.admin.emAdmSysOperateLog.grid.exceptionMessage',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'exceptionStack',
        label: 'label.em.admin.emAdmSysOperateLog.grid.exceptionStack',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'userLoginName',
        label: 'label.em.admin.emAdmSysOperateLog.grid.userLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operateTime',
        label: 'label.em.admin.emAdmSysOperateLog.grid.operateTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessKey',
        label: 'label.em.admin.emAdmSysOperateLog.grid.businessKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessType',
        label: 'label.em.admin.emAdmSysOperateLog.grid.businessType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessDetail',
        label: 'label.em.admin.emAdmSysOperateLog.grid.businessDetail',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessRemark',
        label: 'label.em.admin.emAdmSysOperateLog.grid.businessRemark',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dataId',
        label: 'label.em.admin.emAdmSysOperateLog.grid.dataId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dataEntityClass',
        label: 'label.em.admin.emAdmSysOperateLog.grid.dataEntityClass',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'oldData',
        label: 'label.em.admin.emAdmSysOperateLog.grid.oldData',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'newData',
        label: 'label.em.admin.emAdmSysOperateLog.grid.newData',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'method',
        label: 'label.em.admin.emAdmSysOperateLog.grid.method',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'params',
        label: 'label.em.admin.emAdmSysOperateLog.grid.params',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ipAddress',
        label: 'label.em.admin.emAdmSysOperateLog.grid.ipAddress',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'browser',
        label: 'label.em.admin.emAdmSysOperateLog.grid.browser',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operateDuration',
        label: 'label.em.admin.emAdmSysOperateLog.grid.operateDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysOperateLog.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    moduleNameFilter : "",
    domainNameFilter : "",
    nameFilter : "",
    logLevelFilter : "",
    handleStatusFilter : "",
    exceptionMessageFilter : "",
    exceptionStackFilter : "",
    userLoginNameFilter : "",
    operateTimeRteFilter : "",
    operateTimeLteFilter : "",
    businessKeyFilter : "",
    businessTypeFilter : "",
    businessDetailFilter : "",
    businessRemarkFilter : "",
    dataIdFilter : "",
    dataEntityClassFilter : "",
    oldDataFilter : "",
    newDataFilter : "",
    methodFilter : "",
    paramsFilter : "",
    ipAddressFilter : "",
    browserFilter : "",
    operateDurationFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'moduleNameFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.moduleName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'domainNameFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.domainName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'logLevelFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.logLevel',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'handleStatusFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.handleStatus',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'exceptionMessageFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.exceptionMessage',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'exceptionStackFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.exceptionStack',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'userLoginNameFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.userLoginName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operateTimeRteFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.operateTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'operateTimeLteFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.operateTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'businessKeyFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.businessKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessTypeFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.businessType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessDetailFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.businessDetail',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessRemarkFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.businessRemark',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dataIdFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.dataId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dataEntityClassFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.dataEntityClass',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'oldDataFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.oldData',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'newDataFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.newData',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'methodFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.method',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'paramsFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.params',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ipAddressFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.ipAddress',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'browserFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.browser',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operateDurationFilter',
        label: 'label.em.admin.emAdmSysOperateLog.filter.operateDuration',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'moduleName',
        label: 'label.em.admin.emAdmSysOperateLog.entity.moduleName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'domainName',
        label: 'label.em.admin.emAdmSysOperateLog.entity.domainName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysOperateLog.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'logLevel',
        label: 'label.em.admin.emAdmSysOperateLog.entity.logLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'handleStatus',
        label: 'label.em.admin.emAdmSysOperateLog.entity.handleStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'exceptionMessage',
        label: 'label.em.admin.emAdmSysOperateLog.entity.exceptionMessage',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'exceptionStack',
        label: 'label.em.admin.emAdmSysOperateLog.entity.exceptionStack',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'userLoginName',
        label: 'label.em.admin.emAdmSysOperateLog.entity.userLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operateTime',
        label: 'label.em.admin.emAdmSysOperateLog.entity.operateTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'businessKey',
        label: 'label.em.admin.emAdmSysOperateLog.entity.businessKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessType',
        label: 'label.em.admin.emAdmSysOperateLog.entity.businessType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessDetail',
        label: 'label.em.admin.emAdmSysOperateLog.entity.businessDetail',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'businessRemark',
        label: 'label.em.admin.emAdmSysOperateLog.entity.businessRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dataId',
        label: 'label.em.admin.emAdmSysOperateLog.entity.dataId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dataEntityClass',
        label: 'label.em.admin.emAdmSysOperateLog.entity.dataEntityClass',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'oldData',
        label: 'label.em.admin.emAdmSysOperateLog.entity.oldData',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'newData',
        label: 'label.em.admin.emAdmSysOperateLog.entity.newData',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'method',
        label: 'label.em.admin.emAdmSysOperateLog.entity.method',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'params',
        label: 'label.em.admin.emAdmSysOperateLog.entity.params',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ipAddress',
        label: 'label.em.admin.emAdmSysOperateLog.entity.ipAddress',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'browser',
        label: 'label.em.admin.emAdmSysOperateLog.entity.browser',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operateDuration',
        label: 'label.em.admin.emAdmSysOperateLog.entity.operateDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysOperateLog.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmSysOperateLog, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
